import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MainCalculatorsList from "../MainCalculators";
import RelatedLinks from "../../RelatedLinks";
import { SecondAds,    FirstAds } from "../../../Ads";
import SharedHelmet from "../../Helmet";
import imgUrl from "../../../../images/age-year.webp";
function GregorianYear() {
    const { year } = useParams();
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const currentDay = currentDate.getDate();
    const [birthYear, setBirthYear] = useState(parseInt(year) || 2006);
    const [birthMonth, setBirthMonth] = useState(currentMonth);
    const [birthDay, setBirthDay] = useState(currentDay);
    const [result, setResult] = useState(null);
    const toArabicNumber = (number) => number.toString().replace(/\d/g, (d) => '٠١٢٣٤٥٦٧٨٩'[d]);
    const TITLE = `كم عمر مواليد ${birthYear}`;
    const DESCRIPTION = `احسب عمر مواليد سنة ${birthYear} بدقة حسب التاريخ الميلادي، بالسنوات والأشهر والأيام، مع توضيح مفصل لعمرهم الحالي.`;
    const KEYWORDS = `كم عمر مواليد ${birthYear}, حساب عمر مواليد ${birthYear}, مواليد ${birthYear} كم عمرهم, عمر مواليد ${birthYear} اليوم, احسب عمر مواليد ${birthYear}`;
    const OG_URL = `https://do-calculate.com/calculator/ar/gregorian/${birthYear}/`;
    useEffect(() => {
        if (year && parseInt(year) !== birthYear) {
            setBirthYear(parseInt(year));
        }
        calculateAge();
    }, [year, birthYear, birthMonth, birthDay]);
    const calculateAge = () => {
        const today = new Date();
        const birthDate = new Date(birthYear, birthMonth - 1, birthDay);
        let ageYears = today.getFullYear() - birthDate.getFullYear();
        let ageMonths = today.getMonth() - birthDate.getMonth();
        let ageDays = today.getDate() - birthDate.getDate();
        if (ageDays < 0) {
            ageMonths--;
            const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
            ageDays += lastMonth.getDate();
        }
        if (ageMonths < 0) {
            ageYears--;
            ageMonths += 12;
        }
        const ageWeeks = Math.floor(ageDays / 7);
        const remainingDays = ageDays % 7;
        const diffTime = Math.abs(today - birthDate);
        const totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        setResult({
            years: ageYears,
            months: ageMonths,
            weeks: ageWeeks,
            days: remainingDays,
            totalDays,
            beforeCutoff: `${birthYear}/${currentMonth}/${currentDay}`,
            afterCutoff: `${birthYear}/${currentMonth}/${currentDay + 1}`
        });
    };
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        const numValue = parseInt(value) || 0;
        if (name === "day") {
            setBirthDay(Math.min(31, Math.max(1, numValue)));
        } else if (name === "month") {
            setBirthMonth(Math.min(12, Math.max(1, numValue)));
        }
    };
    return (
        <div className="rtl">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
                IMAGE ={imgUrl}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
                <div className="col-12 col-md-4 text-center">
                    <img
                        src={imgUrl}
                        alt={
                            "كم عمر مواليد " + birthYear + " | احسب عمرك بدقة حسب التاريخ الميلادي"
                        }
                        width="300px"
                        height="300px"
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: "50px" }}>
                        <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
                    </div>
                    <p>
                        مواليد سنة {birthYear} يتساءلون كثيرًا: كم عمرنا الآن؟ في هذه الصفحة، نقدم لك أداة دقيقة لحساب عمر مواليد {birthYear} حسب التاريخ الميلادي، مع توضيح الفرق بالسنوات والأشهر والأيام.
                        سواء كنت تبحث عن "كم عمر مواليد {birthYear}" أو "مواليد {birthYear} كم عمرهم حاليًا"، فستجد الإجابة الواضحة هنا.
                        تساعدك هذه الخدمة على معرفة العمر الحقيقي لأي شخص وُلد في هذه السنة، سواء لأغراض شخصية أو رسمية مثل التقديم للمدارس أو الوظائف أو الخدمات الحكومية.
                        <br/>                        مواليد {birthYear} الآن في أعمار مختلفة حسب تاريخ ميلاد كل شخص، لكن لحساب العمر بدقة، تعتمد الأداة على مقارنة التاريخ الحالي بتاريخ الميلاد مباشرة.
                        للتأكيد: مواليد {toArabicNumber(birthYear)} كم أعمارهم اليوم؟ احسب الآن مجانًا وبدون أي تعقيد.
                    </p>
                    <div className="border border-light">
                        <div className="row">
                            <div className="col calculatorStyle">
                                <div className="p-3 mb-2 bg-success text-white">
                                    <h2 style={{ fontSize: "16px" }}>
                                        {TITLE} {" "}
                                        | حاسبة مواليد {birthYear}
                                    </h2>
                                </div>
                                <div className="row gx-2 gy-2">
                                    <div className="col-12 col-sm-4 d-flex flex-column">
                                        <label htmlFor="birthYear" className="mb-1" style={{marginLeft:'30px'}}>العام:</label>
                                        <input
                                            id="birthYear"
                                            type="number"
                                            value={birthYear}
                                            readOnly
                                            className="form-control text-center"
                                            disabled
                                            aria-label="سنة الميلاد"
                                        />
                                    </div>
                                    <div className="col-12 col-sm-4 d-flex flex-column">
                                        <label htmlFor="birthMonth" className="mb-1" style={{marginLeft:'30px'}}>الشهر:</label>
                                        <input
                                            id="birthMonth"
                                            name="month"
                                            type="number"
                                            value={birthMonth}
                                            onChange={handleDateChange}
                                            min="1"
                                            max="12"
                                            className="form-control text-center"
                                            aria-label="شهر الميلاد"
                                        />
                                    </div>
                                    <div className="col-12 col-sm-4 d-flex flex-column text-center" >
                                        <label htmlFor="birthDay" className="mb-1" style={{marginLeft:'30px'}}>اليوم:</label>
                                        <input
                                            id="birthDay"
                                            name="day"
                                            type="number"
                                            value={birthDay}
                                            onChange={handleDateChange}
                                            min="1"
                                            max="31"
                                            className="form-control text-center"
                                            aria-label="يوم الميلاد"
                                        />
                                    </div>
                                </div>
                                {result && (
                                    <div className="p-3 mb-2  text-center">
                                        <p className="alert alert-success">
                                            عمر مواليد عام {birthYear} الذين ولدوا في أو قبل تاريخ {result.beforeCutoff} هو <strong>{result.years} سنة</strong>
                                        </p>
                                        <p className="alert alert-success">
                                            عمر مواليد عام {birthYear} الذين ولدوا بعد تاريخ {result.beforeCutoff} هو <strong>{result.years - 1} سنة</strong>
                                        </p>
                                        <hr className="bg-white" />
                                        <p className="alert alert-info ">
                                            <b> العمر بالتفصيل</b>: {result.years} سنة، {result.months} شهر، {result.weeks} أسبوع، {result.days} يوم
                                        </p>
                                        <p className="alert alert-info"><b>إجمالي الأيام:</b> {result.totalDays} يوم</p>
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <hr />
            <div className="row" style={{ height: "auto" }}>
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h2 style={{ fontSize: '16px' }}>كم عمر مواليد {birthYear}؟ شرح طريقة حساب العمر</h2>
                            </div>
                            <div className="info-section-body">
                                <div>
                                    <h3>كيفية حساب عمر مواليد {birthYear}</h3>
                                    <p>
                                        لحساب عمر شخص وُلد في سنة {birthYear}، تتم مقارنة تاريخ الميلاد بالتاريخ الحالي. الطريقة تكون كالتالي:
                                    </p>
                                    <ul>
                                        <li>إذا كان عيد الميلاد قد مر: العمر = السنة الحالية - {birthYear}</li>
                                        <li>إذا لم يأتِ عيد الميلاد بعد: العمر = (السنة الحالية - {birthYear}) - 1</li>
                                    </ul>
                                    <div className="p-3 bg-info text-dark">
                                        <h4>أمثلة على حساب العمر بدقة:</h4>
                                        <ul>
                                            <li>تاريخ الميلاد 01/01: العمر {currentYear - birthYear} سنة</li>
                                            <li>تاريخ الميلاد 31/12: العمر {currentYear - birthYear - 1} سنة</li>
                                        </ul>
                                    </div>
                                    <p>
                                        مواليد {birthYear} كم عمرهم الآن؟ هذه الأداة تساعدك على معرفة العمر بالسنوات والأشهر والأيام.
                                    </p>
                                    <p>
                                        هل تسأل: {birthYear} كم عمره؟ أو مواليد {birthYear} أعمارهم كم؟ إليك الجواب.
                                    </p>
                                    <p>
                                        للتأكيد: مواليد {toArabicNumber(birthYear)} كم عمرهم اليوم؟
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default GregorianYear;